// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1v_gY","productName":"Table_productName__3kCkh"};